import { createFileRoute } from "@tanstack/react-router";
import { DashboardCard, CrudShellHeader, MERCHANT_HUB_GRID } from "@/components/ds";
import { ClinicalPageShell } from "@/components/clinical";
import { getOperacionesHubLinks } from "@/lib/workspace-hubs";
import { useTenantContext } from "@/lib/tenant-context";
import { MerchantExperienceBar } from "@/components/renata/MerchantExperienceBar";

export const Route = createFileRoute("/app/operaciones/")({
  component: OperacionesHubPage,
  head: () => ({ meta: [{ title: "Abastecimiento — Structura Market" }] }),
});

function OperacionesHubPage() {
  const { businessProfile } = useTenantContext();
  const links = getOperacionesHubLinks(undefined, businessProfile);

  return (
    <div>
      <CrudShellHeader title="Abastecimiento" description="Compras a proveedores · no incluye pedidos de clientes" />
      <ClinicalPageShell offset="none" className="pt-6">
        <MerchantExperienceBar screenId="abastecimiento" />
        <div className="mb-4">
          <p className="text-sm font-semibold text-foreground">¿Qué querés gestionar?</p>
          <p className="text-xs text-muted-foreground">Solo cadena de suministro: recepciones, OC a proveedores y recompras</p>
        </div>
        <div className={MERCHANT_HUB_GRID} data-tour="workspace-hub">
          {links.map((link) => (
            <DashboardCard
              key={link.id}
              to={link.href}
              search={link.search}
              icon={link.icon}
              title={link.label}
              subtitle={link.description ?? ""}
            />
          ))}
        </div>
      </ClinicalPageShell>
    </div>
  );
}
